import { mergeProps } from 'solid-js';
import { ApplicationTypeEnum } from '~/api';
import { Localized } from '~/i18n';
import { getTranslationKey } from './utils';
import { externalLinks } from '~/consts';
import Link from '~/components/Link';
import { SquareArrowOutUpRight } from 'lucide-solid';

type MultiAppDocsLinksProps = {
  applicationType: ApplicationTypeEnum;
};

export default function MultiAppDocsLinks(props: MultiAppDocsLinksProps) {
  const merged = mergeProps({}, props);

  const getSubheaderComponent = (translationKey: string, href: string) => {
    return (
      <div class="flex items-center gap-2">
        <Localized translationKey={translationKey} />
        <Link
          href={href}
          target="_blank"
          class="flex items-center gap-1 text-sm text-link-primary"
        >
          <Localized translationKey={getTranslationKey('learn_more')} />
          <SquareArrowOutUpRight
            width={14}
            height={14}
          />
        </Link>
      </div>
    );
  };

  switch (merged.applicationType) {
    case ApplicationTypeEnum.DEFAULT_APPLICATION:
      return getSubheaderComponent(
        getTranslationKey('web_application_subheader'),
        externalLinks.multiApplicationsLinks.webApplication
      );
    case ApplicationTypeEnum.WEB_APPLICATION:
      return getSubheaderComponent(
        getTranslationKey('web_application_subheader'),
        externalLinks.multiApplicationsLinks.webApplication
      );
    case ApplicationTypeEnum.SINGLE_PAGE_APPLICATION:
      return getSubheaderComponent(
        getTranslationKey('single_page_application_subheader'),
        externalLinks.multiApplicationsLinks.singlePageApplication
      );
    case ApplicationTypeEnum.NATIVE_APPLICATION:
      return getSubheaderComponent(
        getTranslationKey('native_application_subheader'),
        externalLinks.multiApplicationsLinks.nativeApplication
      );
    default:
      return null;
  }
}
